import "core-js/modules/es6.regexp.split";
import VueI18n from 'vue-i18n';
import Vue from 'vue';
import messages from '@/assets/locales/es';
Vue.use(VueI18n);
export var i18n = new VueI18n({
  locale: navigator.language.split('-')[0],
  fallbackLocale: 'es',
  messages: messages
});